import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

import BannerInput from "../bannerInput";
import AirportResults from "../containerSearch/airport-results";
import "../containerSearch/style.css";
import "./airport-mobile-list.css";

const AirportMobileList = ({
  airports,
  keyword,
  setKeyword,
  onItemClick,
  placeholder,
  excludeCityCode,
}) => {
  return (
    <div className="airport-mobile-list">
      <div className="airport-search__input">
        <SearchRoundedIcon className="airport-search__input-icon" />
        <BannerInput
          placeholder={placeholder}
          onChange={(e) => setKeyword(e.target.value)}
          value={keyword}
          autoFocus
        />
        {keyword && (
          <IconButton
            className="airport-mobile-list__clear"
            onClick={() => setKeyword("")}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </div>

      <div className="airport-search__body airport-mobile-list__body">
        <AirportResults
          query={keyword}
          results={airports?.data}
          loading={airports?.loading}
          onSelect={onItemClick}
          excludeCityCode={excludeCityCode}
        />
      </div>
    </div>
  );
};

export default AirportMobileList;
